<ion-item>

  <ion-thumbnail slot="start">
    <yu-icon name="user" color="medium"></yu-icon>
  </ion-thumbnail>

  <ion-label>
    <p class="title">{{ info.usuario }}</p>

    <div class="data">
      <p>{{ 'RRHH.FOLDERS.DETAIL.TIME' | translate }} <span>{{ info.tiempo_visto_ver }} ({{ info.veces_visto }} {{ info.veces_visto === 1 ? ' vez' : ' veces' }})</span></p>
      <p>{{ 'RRHH.FOLDERS.DETAIL.LAST_TIME' | translate }} <span>{{ info.ultima_vista.original | date: 'dd/MM/yyyy HH:mm:ss' }}</span></p>
    </div>
  </ion-label>

</ion-item>
